import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  removeZipCodeMask,
  SelectRemote,
  ZipCodeInput,
} from '@repo/ui';
import { FormikValues } from 'formik';
import React from 'react';
import { Col, Input, Label } from 'reactstrap';

import { useAddress } from '../../../hooks/useAddress';

interface PersonFormAddressFieldsProps {
  validation: FormikValues;
}

export const PersonFormAddressFields = ({
  validation,
}: PersonFormAddressFieldsProps) => {
  const {
    cities,
    setCities,
    loadingCities,
    zipCodeSchema,
    requestGetCities,
    loadingAddressByZipCode,
    requestGetAddressByZipCode,
  } = useAddress({ validation });

  return (
    <React.Fragment>
      <Col md={3}>
        <Label htmlFor="zipcode">CEP</Label>
        <ZipCodeInput
          id="zipcode"
          name="zipcode"
          onChange={(e) => {
            const { value } = e.target;

            if (value && zipCodeSchema.isValidSync(value)) {
              requestGetAddressByZipCode({
                zipCode: removeZipCodeMask(value),
              });
            }

            validation?.handleChange(e);
          }}
          onBlur={validation?.handleBlur}
          value={validation?.values?.zipcode}
          disabled={loadingAddressByZipCode}
        />
      </Col>

      <Col md={6}>
        <Label htmlFor="street" className="form-label">
          Logradouro
        </Label>
        <Input
          id="street"
          name="street"
          type="text"
          disabled={loadingAddressByZipCode}
          className="form-control"
          value={validation.values.street}
          onChange={validation.handleChange}
        />
      </Col>

      <Col md={3}>
        <Label htmlFor="addressNumber" className="form-label">
          Número
        </Label>
        <Input
          type="text"
          id="addressNumber"
          name="addressNumber"
          className="form-control"
          onChange={validation.handleChange}
          value={validation.values.addressNumber}
        />
      </Col>

      <Col md={5}>
        <Label htmlFor="addressComplement" className="form-label">
          Complemento
        </Label>
        <Input
          type="text"
          id="addressComplement"
          name="addressComplement"
          className="form-control"
          onChange={validation.handleChange}
          disabled={loadingAddressByZipCode}
          value={validation.values.addressComplement}
        />
      </Col>

      <Col md={3}>
        <Label htmlFor="district" className="form-label">
          Bairro
        </Label>
        <Input
          type="text"
          id="district"
          name="district"
          className="form-control"
          disabled={loadingAddressByZipCode}
          value={validation.values.district}
          onChange={validation.handleChange}
        />
      </Col>

      <Col md={4}>
        <Label htmlFor="city" className="form-label">
          Cidade
        </Label>
        <SelectRemote
          isClearable
          name="city"
          isDisabled={loadingAddressByZipCode}
          clearOptions={() => setCities([])}
          functionSearch={(e) => {
            requestGetCities({ search: e });
          }}
          inputId={'city'}
          onChange={(e) => {
            validation?.handleChange(convertEventSelectToTarget('city', e));
          }}
          onBlur={validation.handleBlur}
          options={formatDataToLabelValue(cities, 'id', 'name')}
          value={validation?.values?.city}
          loading={loadingCities}
        />
      </Col>
    </React.Fragment>
  );
};
